import agenda from './agenda'
import banners from './banners'
import boosts from './boosts'
import categories from './categories'
import sponsorships from './sponsorships'
import streamers from './streamers'
import subcategories from './subcategories'
import subscriptions from './subscriptions'

const tv = [
	...agenda,
	...categories,
	...subcategories,
	...streamers,
	...banners,
	...subscriptions,
	...sponsorships,
	...boosts,
	{
		path: '/tv/dashboard',
		name: 'tv-dashboard',
		component: () => import('@/views/tv/dashboard/Index.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,streamers',
		},
	},
	{
		path: '/tv/messages',
		name: 'tv-messages-list',
		component: () => import('@/views/messages/Messages.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,messages',
		},
	},
	{
		path: '/tv/newsletter',
		name: 'tv-newsletter-list',
		component: () => import('@/views/newsletters/Newsletter.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,newsletter',
		},
	},
	{
		path: '/tv/notifications',
		name: 'tv-notifications-list',
		component: () => import('@/views/notifications/Notifications.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,notifications',
		},
	},
	{
		path: '/tv/walls/list',
		name: 'tv-walls-list',
		component: () => import('@/views/tv/walls/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,streamers',
		},
	},
	{
		path: '/tv/walls/payouts',
		name: 'tv-walls-payouts',
		component: () => import('@/views/tv/walls/payouts.vue'),
		meta: {
			layout: 'content',
			module: 'MGTV,streamers',
		},
	},
]

export default tv
